import React from "react";
import { styles } from "../../utils/styles/our-brands-styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { colors } from "../../utils/const";
import { useI18n } from "@/i18n/I18nProvider";
import dynamic from "next/dynamic";
import Image from "next/image";
import Head from "next/head";

import PageHead from "@/components/PageHead"; // 👈 خليه static (أفضل للـ hydration)
import { getOurBrandsText } from "../../../locales/our-brands";

const ContentCard = dynamic(() => import("../../components/our-brands/ContentCard"));
const SmallTitle = dynamic(() => import("@/components/mini-components/SmallTitle"));

export default function Index() {
  const { t, locale } = useI18n();
  const ourBrandsText = getOurBrandsText(locale);


  const body = ourBrandsText?.our_brand_page?.body || [];

  // بدل map مرتين
  const { leftItems, rightItems } = React.useMemo(() => {
    const left = [];
    const right = [];
    for (const it of body) {
      if (it?.id <= 5) left.push(it);
      else right.push(it);
    }
    return { leftItems: left, rightItems: right };
  }, [body]);

  return (
    <>
      <PageHead
        title={t?.pages_main_tags?.ourBrands.title}
        description={t?.pages_main_tags?.ourBrands.meta_desc}
      />

      {/* تحسين LCP: preconnect للـ S3 اللي عليها صورة الـ hero */}
      <Head>
        <link rel="preconnect" href="https://contact-app-prod.s3.us-east-2.amazonaws.com" />
        <link rel="dns-prefetch" href="https://contact-app-prod.s3.us-east-2.amazonaws.com" />
      </Head>


      <Box sx={styles.container}>
        <Box
          className="section-safe-padding-bottom section-safe-padding-top horizontal-safe-margin"
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: "space-between" },
            alignItems: "center",
            flexDirection: "row",
            flexWrap: { xs: "wrap", md: "nowrap" },
            gap: "10px",
          }}
        >
          <Box>
            <Box sx={{ mb: 5 }}>
              <SmallTitle h1="h1" title={ourBrandsText.our_brand_page.Contactfinancialholding2} />
            </Box>

            <Typography
              component="p"
              sx={{
                fontSize: "16px",
                fontWeight: 500,
                maxWidth: "650px",
                mt: 2,
              }}
            >
              {ourBrandsText.brand_description}
            </Typography>

            <Typography
              component="p"
              sx={{ mt: 2, fontWeight: 600, color: colors.bastille, maxWidth: "650px" }}
            >
              {t.contact_supervision}
            </Typography>
          </Box>

          {/* LCP + CLS fix: Next/Image + priority + sizes + أبعاد ثابتة */}
          <Box
            sx={{
              width: "100%",
              maxWidth: { xs: "300px", sm: "500px", lg: "650px", xl: "700px" },
            }}
          >
            <Image
              src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brand-cover.webp"
              alt="Contact brands cover"
              width={700}
              height={334}
              priority
              sizes="(max-width: 600px) 300px, (max-width: 900px) 500px, (max-width: 1200px) 650px, 700px"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: 16,
              }}
            />
          </Box>
        </Box>

        <Box sx={styles.body} className="section-safe-padding-bottom horizontal-safe-margin">
          {/* LEFT */}
          <Box sx={{ flex: "1", display: "flex", flexDirection: "column", gap: "30px" }}>
            <Box sx={{ color: "#2d317f", fontSize: "30px", fontWeight: "bold" }}>
              <SmallTitle h2="h2" title={ourBrandsText.our_brand_page.title1} />
            </Box>

            {leftItems.map((item, idx) => (
              <ContentCard
                key={item.id}
                id={item.id}
                img={item.img}
                content={item.content}
                heading={item.heading}
                supervision={item.supervision}
                link1={item.link1}
                link2={item.link2}
                link3={item.link3}
                topLine={idx !== 0}
              />
            ))}
          </Box>

          {/* Divider */}
          <Box sx={{ display: { xs: "none", sm: "initial" } }}>
            <Box
              sx={{
                height: "100%",
                border: "1px solid #e4e7ec",
                mx: { sm: 6, md: 10 }, // responsive بدل mr/ml جامدين
              }}
            />
          </Box>

          {/* RIGHT */}
          <Box sx={{ flex: "1", display: "flex", flexDirection: "column", gap: "30px" }}>
            <Box sx={{ mt: { xs: 4, md: 0 } }}>
              <SmallTitle h2="h2" title={ourBrandsText.our_brand_page.title2} />
            </Box>

            {rightItems.map((item, idx) => (
              <ContentCard
                key={item.id}
                id={item.id}
                img={item.img}
                content={item.content}
                heading={item.heading}
                supervision={item.supervision}
                link1={item.link1}
                link2={item.link2}
                link3={item.link3}
                topLine={idx !== 0}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
}
